import React from 'react';
import { formatCurrency } from '@/utils/format';

interface BoqImportPreviewTableProps {
  data: any[];
}

export function BoqImportPreviewTable({ data }: BoqImportPreviewTableProps) {
  if (!data || data.length === 0) return null;

  return (
    <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead className="bg-slate-50 border-b border-slate-200 font-normal">
            <tr>
              <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest">Mã hiệu</th>
              <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest">Tên hạng mục</th>
              <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest text-center">ĐVT</th>
              <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest text-right">Khối lượng</th>
              <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest text-right">Đơn giá</th>
              <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest text-right">Thành tiền</th>
              <th className="px-4 py-3 text-[10px] font-normal text-slate-500 tracking-widest text-center">Trạng thái</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {data.map((item, idx) => (
              <tr key={idx} className="hover:bg-slate-50 transition-colors group">
                <td className="px-4 py-3 text-sm font-medium text-slate-600 font-mono">{item.item_code}</td>
                <td className="px-4 py-3">
                  <div className="text-sm font-bold text-slate-900">{item.item_name}</div>
                  {item.description && <div className="text-xs text-slate-400 mt-0.5">{item.description}</div>}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 text-center">{item.unit}</td>
                <td className="px-4 py-3 text-sm text-slate-900 font-medium text-right">{item.quantity}</td>
                <td className="px-4 py-3 text-sm text-slate-600 text-right">{formatCurrency(item.unit_price)}</td>
                <td className="px-4 py-3 text-sm font-bold text-os-primary text-right">{formatCurrency(item.total_amount)}</td>
                <td className="px-4 py-3 text-center">
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-600 text-[10px] font-bold ">
                    <i className="ri-checkbox-circle-line" /> Hợp lệ
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="bg-slate-50 px-4 py-3 border-t border-slate-200 flex justify-between items-center">
        <p className="text-xs text-slate-500 font-medium">
          Hiển thị <span className="text-slate-900 font-bold">{data.length}</span> bản ghi tìm thấy trong file
        </p>
        <div className="text-xs text-slate-400">
          * Vui lòng kiểm tra kỹ trước khi nhấn Xác nhận Import
        </div>
      </div>
    </div>
  );
}
